import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-south-carolina-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./south-carolina-state-form.component.html",
  styleUrl: "./south-carolina-state-form.component.scss",
})
export class SouthCarolinaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
